export default {
  "t-physical-examination": "Health Check",
  "t-physical-examination-logs": "Health Check Report",
  "t-terminal-data-upload-configuration": "Terminal Data Upload Configuration",
  "t-terminal-strategy-parameters": "Terminal Strategy Parameters",
  "t-strategy-execution-report": "Strategy Execution Report",
  "t-terminal-data-analysis": "Terminal Data Analysis",
  "t-configuration-parameters": "Configuration Parameters",
  "t-data-alert-config": "Data & Alert Config",
  "t-data-upload-alert-event-config": "Data Upload & Alert Event Config",
  "t-history": "History",
  "t-health-check-date": "Health Check Date",
  "t-health-score": "Health Score",
  "t-check-items": "Check Items",
  "t-pass-rate": "Pass Rate",
  "t-detection-status": "Hardware Check Status",
  "t-device-basic-info": "Device Basic Information",
  "t-healthy": "Healthy",
  "t-optimal": "Normal",
  "t-unhealthy": "Unhealthy",
  "t-skip": "Skip",
  "t-printer": "Printer",
  "t-voltage": "Voltage",
  "t-temperature": "Temperature",
  "t-charging-status": "Charging Status",
  "t-print-distance": "Print Distance",
  "t-print-head-size": "Print Head Size",
  "t-bootloader-version": "Bootloader Version",
  "t-internal-software-version": "Internal Software Version",
  "t-uptime": "Uptime",
  "t-detection-content": "Tested {total} items in total, passed {pass} items, skipped {skip} items",
  "t-not-charging": "Not Charging",
  "t-charging": "Charging",
  "t-closed": "Closed",
  "t-opened": "Opened",
  "t-mobile-data": "Mobile Data",
  "t-wifi": "WIFI",
  "t-unknown": "Unknown",
  "t-medical-inspection": "Health Check Type",
  "t-health-status": "Health Status",
  "t-manual": "Manual",
  "t-automatic": "Automatic",
  "t-manual-physical-examination-type": "Manual",
  "t-automatic-physical-examination-type": "Automatic",
  "t-device-data-acquisition": "Device Data Acquisition",
  "t-device-data-stop-collection": "Stop Device Data Acquisition",
  "t-device-health-check": "Device Health Check",
  "t-auto-health-check": "Auto Health Check",
  "t-tha-logs": "THA Health Check Logs",
  "t-battery-brand": "Brand",
  "t-battery-mfg-date": "Manufacture Date",
  "t-charging-duration": "Charging Duration",
  "t-charging-current": "Charging Current",
  "t-charge-cycles": "Charge Cycles",
  "t-charge-cycle-count": "Charge Cycle Count",
  "t-low-temperature-warning-count": "Low Temperature Warning Count",
  "t-low-temp-shutdown-count": "Low Temp Shutdown Count",
  "t-high-temperature-warning-count": "High Temperature Warning Count",
  "t-high-temp-shutdown-count": "High Temp Shutdown Count",
  "t-data-upload": "THA Data List",
  "t-alert-event": "THA Alert Event",
  "t-device-config": "THA Device Config",
  "t-config-sync-log": "THA Config Sync Log",
  "t-event-trigger-time": "Event Trigger Time",
  "t-event-upload-time": "Event Upload Time",
  "t-battery-overheating": "Battery High Temperature Warning",
  "t-battery-undervoltage": "Battery Low Temperature Warning",
  "t-cpu-overheating": "Battery High Temperature Shutdown",
  "t-event-battery-high-temperature": "Battery High Temperature Warning",
  "t-event-battery-low-temperature": "Battery Low Temperature Warning",
  "t-event-cpu-high-temperature": "CPU High Temperature",
  "t-event-battery-high-temperature-shutdown": "Battery High Temperature Shutdown",
  "t-event-battery-low-temperature-shutdown": "Battery Low Temperature Shutdown",
  "t-event-type": "Event Type",
  "t-total-records": "Total Records",
  "t-peripheral": "Peripheral",
  "t-module": "Module",
  "t-sampling-period": "Sampling Period",
  "t-sampling-period-1-minute": "1 Minute",
  "t-sampling-period-3-minutes": "3 Minutes",
  "t-sampling-period-5-minutes": "5 Minutes",
  "t-sampling-period-10-minutes": "10 Minutes",
  "t-sampling-period-30-minutes": "30 Minutes",
  "t-sampling-period-60-minutes": "60 Minutes",
  "t-upload-interval": "Upload Interval",
  "t-upload-interval-less-than-sampling-period": "Upload Interval cannot be less than Sampling Period",
  "t-sample-count": "Sample Count",
  "t-valid-sample-count": "Valid Sample Count",
  "t-upload-timestamp": "Upload time",
  "t-sample-timestamp": "Latest reporting time",
  "t-config-sync-logs": "Config Sync Logs",
  "t-data-point": "Data Point",
  "t-policy-updated": "Policy Has Been Updated",
  "t-policy-consistent": "Policy Is Consistent",

  // 应用信息
  "t-app-name": "App Name",
  "t-package-name": "Package Name",
  "t-is-system": "Is System App",
  "t-app-version": "App Version",
  "t-authorisations": "Authorisations",
  "t-installed-at": "Installed At",
  "t-app-size": "Size",
  // 网络流量统计
  "t-uplink-traffic": "Uplink Traffic",
  "t-downlink-traffic": "Downlink Traffic",
  "t-traffic-total": "Total Traffic",
  "t-monitor-more": "more",
  // 网络连接状态
  "t-router-name": "Router Name",
  // 外设使用统计
  "t-swipe-card-count": "Swipe Card Count",
  "t-insert-card-count": "Insert Card Count",
  "t-tap-card-count": "Tap Card Count",
  "t-card-fail-count": "Card Fail Count",
  "t-print-mileage": "Print Distance",
  "t-print-speed": "Print Speed",
  "t-print-grayscale": "Print Grayscale",

  "t-open-tha-model-waiting": "THA request has been initiated, please wait ..",
  "t-manually-initiated-health-check-failed": "Manually initiated health check failed",
  "t-health-check-initialization-failed": "Health check initialization failed",
  "t-manually-initiated-health-check-success": "Health check initiated successfully, please check it in the Health Check Report",
  "t-monitor-abnormal": "Abnormal",
  "t-monitor-start-date": "Start Date",
  "t-monitor-end-date": "End Date",
  "t-monitor-battery-status": "Battery Status",
  "t-monitor-battery-health": "Battery Health",
  "t-monitor-current-capacity": "Battery Level",
  "t-monitor-current-capacity-percent": "Capacity Percent",
  "t-monitor-mcu-backup-power": "MCU Backup Power",
  "t-monitor-mcu-backup-status": "Backup Status",
  "t-monitor-key-focus": "Key Focus",
  "t-monitor-battery-trend": "Battery Trend",
  "t-monitor-temperature-battery-threshold": "Temperature Threshold / Battery Threshold",
  "t-monitor-system-resource-trend": "System Resource Trend",
  "t-monitor-storage-high": "High Storage Usage",
  "t-monitor-network-traffic-trend": "Network & Traffic Trend",
  "t-monitor-link-stable": "Stable Link",
  "t-monitor-data-summary": "Data Summary",
  "t-monitor-metric": "Metric",
  "t-monitor-current-value": "Current",
  "t-monitor-minimum-value": "Minimum",
  "t-monitor-maximum-value": "Maximum",
  "t-monitor-average-value": "Average",
  "t-threshold": "Threshold",
  "t-monitor-unit-times": "times",
  "t-monitor-unit-meter": "m",
  "t-monitor-no-sampling-time": "No sampling time",
  "t-monitor-device-info": "Device Info",
  "t-monitor-software-version": "Software Version",
  "t-monitor-sma-version": "SMA Version",
  "t-monitor-pos-service": "POS Service",
  "t-monitor-network-connection": "Network Connection",
  "t-monitor-ip-address": "IP Address",
  "t-monitor-mac-address": "MAC Address",
  "t-monitor-battery-info": "Battery Info",
  "t-monitor-battery-brand": "Battery Brand",
  "t-monitor-collection-summary": "Collection Summary",
  "t-monitor-valid-rate": "Valid Rate",
  "t-monitor-battery-level": "Battery",
  "t-monitor-current": "Current",
  "t-monitor-over-threshold": "Over Threshold",
  "t-monitor-below-threshold": "Below Threshold",
  "t-monitor-idle": "Idle",
  "t-monitor-charge-cycle-stats": "Charge Cycle Statistics",
  "t-monitor-high": "High",
  "t-monitor-charge-count": "Charge Count",
  "t-monitor-cumulative": "Cumulative",
  "t-monitor-current-cycle": "Current Cycle",
  "t-monitor-high-temperature-warning": "High Temp Warning",
  "t-monitor-high-temp-shutdown": "High Temp Shutdown",
  "t-monitor-severe": "Severe",
  "t-monitor-controllable": "Controllable",
  "t-monitor-low-temperature-warning": "Low Temp Warning",
  "t-monitor-low-temp-shutdown": "Low Temp Shutdown",
  "t-monitor-system-resource": "System Resource",
  "t-monitor-network-signal": "Network Signal",
  "t-monitor-weak": "Weak",
  "t-monitor-good": "Good",
  "t-monitor-stable": "Stable",
  "t-monitor-application-traffic": "Application Traffic",
  "t-monitor-current-sample": "Current Sample",
  "t-monitor-peripheral-stats": "Peripheral Stats",
  "t-monitor-need-attention": "Needs Attention",
  "t-monitor-usage": "Usage",
  "t-monitor-ethernet": "Ethernet",
  "t-monitor-link-normal": "Link Normal",
  "t-monitor-fetch-failed": "Failed to fetch monitor data",
  "t-version-change-timeline": "Software Version Change Timeline",
  "t-version-change-count": "{count} version changes",
  "t-version-timeline-empty": "No version change records",
  "t-version-timeline-multiple-events": "Multiple events",
  "t-version-timeline-event": "Event",
  "t-version-timeline-init": "Initialization",
  "t-version-timeline-update": "Version Update",
  "t-version-timeline-upgrade": "Upgrade",
  "t-version-timeline-rollback": "Rollback",
  "t-version-timeline-exception": "Exception",
  "t-version-timeline-current": "Current",
  "t-data-upload-data": "THA Data Overview",
  "t-tha-data-overview": "THA Data Overview",
  "t-manual-physical-examination-and-automatic-physical-examination": "During manual physical examination, the device must install POS Manager, this application is used to detect the display screen, touch screen, camera, speaker, buttons, fingerprint sensor, microphone, magnetic stripe reader, chip reader, contactless reader, printer, status indicator light, buzzer and payment secure storage module. It also includes automatic physical examination items: device serial number, examination time, Bluetooth status, current CPU usage, current RAM usage, current storage memory usage, boot time, location, charging status, battery temperature, battery voltage, battery charge level, communication type, signal type, router address, transmission speed, WiFi MAC address, signal strength, network switch, and print distance",
  "t-manual-physical-examination-and-automatic-physical-examination-auto": "During automatic physical examination, the device does not need to install POS Manager, this application is used to detect device serial number, examination time, Bluetooth status, current CPU usage, current RAM usage, current storage memory usage, boot time, location, charging status, battery temperature, battery voltage, battery charge level, communication type, signal type, router address, transmission speed, WiFi MAC address, signal strength, network switch, and print distance",
  "t-power-level": "Level",
}
